import React from 'react';
import Layout from '../components/Layout';
import About from '../components/About';
import {graphql} from 'gatsby';

export default function about(props) {
  return (
    <Layout>
      <About
        data={{
          ...props.data.userJson.about,
          ...props.data.userJson.navbar,
        }}
      />
    </Layout>
  );
}

export const query = graphql`
    query AboutData {
        userJson {
            navbar {
                title
            }
            about {
                name
                img {
                    relativePath
                    childImageSharp {
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
                description1
                description2
                myInterest
                myBackground {
                    experience
                    language
                    nationality
                }
                profiles {
                    name
                    link
                }
            }
        }
    }
`;
